(function (Drupal) {
  Drupal.behaviors.lieuxTabs = {
    attach: function (context, settings) {
      const tabs = context.querySelectorAll(".lieux-list li a");
      const firstTab = context.querySelector(".lieux-list li:first-child a");
      const firstItem = context.querySelector(".item .lieux-item:first-child");

      if (firstTab) {
        firstTab.classList.add("active");
      }

      if (firstItem) {
        firstItem.classList.add("active");
      }

      tabs.forEach((tab) => {
        if (!tab.dataset.lieuxTabsProcessed) {
          tab.dataset.lieuxTabsProcessed = "true";
          tab.addEventListener("click", (e) => {
            e.preventDefault();

            tabs.forEach((t) => t.classList.remove("active"));
            tab.classList.add("active");

            const itemId = tab.getAttribute("data-item");
            const items = context.querySelectorAll(".lieux-item");
            items.forEach((item) => item.classList.remove("active"));

            const activeItem = context.querySelector(`#${itemId}`);
            if (activeItem) {
              activeItem.classList.add("active");
            }
          });
        }
      });
    },
  };
})(Drupal);
